/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { forwardRef, ChangeEvent, useState, ReactNode } from 'react';

import { Input } from '../Input/Input';

type CustomTextFieldProps = {
  helperText?: string;
  label?: string;
  mask?: (value: string) => string;
  icon?: ReactNode;
} & React.InputHTMLAttributes<HTMLInputElement>;

// eslint-disable-next-line react/display-name
const CustomInputMask = forwardRef<HTMLInputElement, CustomTextFieldProps>(
  ({ label, mask, onChange, icon, ...props }, ref) => {
    const [inputValue, setInputValue] = useState(props.value || '');

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const rawValue = e.target.value;
      const maskedValue = mask ? mask(rawValue) : rawValue;

      setInputValue(maskedValue);
      if (onChange) onChange(e);
    };

    return (
      <Input
        {...props}
        label={label}
        ref={ref}
        value={inputValue}
        onChange={handleChange}
        helperText={Boolean(props.helperText) ? props.helperText : ''}
        icon={icon}
      />
    );
  }
);

export default CustomInputMask;
